import { Box, Card, IconButton, Tooltip } from "@mui/material";
import CustomTable from "../form/CustomTable";
import CustomText from "../form/CustomText";
import { ViewIcon } from "../../theme/SvgIcons";
import { CustomLoader, SearchField } from "../../utils/common_functions";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getVerifiedUsers } from "../../redux/users/action";
import { useEffect, useState } from "react";
import NavBar from "../navbar";
import colors from "../../theme/colors";
import EllipseText from "../form/EllipseText";

const tableText = (text) => {
  return <CustomText variant="body_1">{text}</CustomText>;
};
export const column = [
  {
    id: "name",
    label: tableText("Name"),
  },
  {
    id: "user_name",
    label: tableText("User Name"),
  },
  {
    id: "email",
    label: tableText("Email"),
  },
  {
    id: "reason",
    label: tableText("Reason"),
  },
  {
    id: "Refer_to_data",
    label: tableText("Referral by"),
  },
  {
    id: "country",
    label: tableText("Country"),
  },
  {
    id: "createdAt",
    label: tableText("Registered"),
  },
  {
    id: "action",
    label: tableText("Actions"),
  },
];

const rows = (verified_users, searchText, profileView) => {
  if (Array.isArray(verified_users)) {
    if (verified_users) {
      return verified_users.map((el, index) => ({
        name: <CustomText variant="body_1">{el?.name}</CustomText>,
        user_name: (
          <CustomText variant="gray_title">{el?.user_name}</CustomText>
        ),
        email: <CustomText variant="gray_title">{el?.email}</CustomText>,
        reason: (
          <Tooltip title={el.deactivate_reason} placement="bottom-end">
            <div>
              <EllipseText variant="gray_title">
                {el.deactivate_reason}
              </EllipseText>
            </div>
          </Tooltip>
        ),
        Refer_to_data: (
          <CustomText variant="gray_title">
            {el?.Refer_to_data[0]?.Refer_by_data?.user_name}
          </CustomText>
        ),
        country: <CustomText variant="gray_title">{el.country}</CustomText>,
        createdAt: (
          <CustomText variant="gray_title">
            {el?.createdAt.split("T")[0]}
          </CustomText>
        ),
        action: (
          <IconButton
            sx={{ width: "40px", height: "40px" }}
            onClick={() => profileView(el.id)}
          >
            <ViewIcon />
          </IconButton>
        ),
      }));
    } else {
      return [];
    }
  } else {
    return [];
  }
};
const VerifyUsers = (props) => {
  const { verified_users, verify_loading, verified_count } = useSelector(
    (e) => e.users
  );
  const { isLoading } = useSelector((e) => e.userInfo);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileView = (id) => {
    navigate(`/admin/profile/id=${id}`, { state: { name: "de-activate" } });
  };

  useEffect(() => {
    if (verified_users === undefined) {
      dispatch(
        getVerifiedUsers(
          { status: 0 },
          `&page=${page + 1}&limit=${rowsPerPage}&search=${searchText}`
        )
      );
    }
  }, [verified_users]);

  // useEffect(() => {
  //   dispatch(getVerifiedUsers({ status: 0 }, ""));
  // }, []);

  const brcrmb = [
    { name: "Users", path: "/admin/deactive-user" },
    { name: "Deactive", path: "", noRedirect: true },
  ];

  const handleGetListingData = (newPage, rowsPerPage, searchText = "") => {
    const queryParam = `&page=${
      newPage + 1
    }&limit=${rowsPerPage}&search=${searchText}`;
    dispatch(getVerifiedUsers({ status: 0 }, queryParam));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handleGetListingData(newPage, rowsPerPage, searchText);
  };

  const handleChangeRowsPerPage = (event) => {
    let rowPerPage = parseInt(event.target.value, 10);
    setPage(0);
    setRowsPerPage(rowPerPage);
    handleGetListingData(page, rowPerPage, searchText);
  };

  let ref;
  useEffect(() => {
    if (verified_users !== undefined) {
      ref = setTimeout(
        () => handleGetListingData(0, rowsPerPage, searchText),
        1000
      );
      setPage(0);
    }
    return () => clearTimeout(ref);
  }, [searchText]);

  return (
    <>
      <NavBar option={brcrmb} />
      <Card sx={{ m: "20px 36px 50px 36px" }}>
        <Box sx={{ m: "30px", display: "flex", alignItems: "center" }}>
          <CustomText
            sx={{
              fontSize: "18px",
              fontWeight: "500",
              width: "190px",
              color: `${colors.nero}!important`,
            }}
          >
            Deactive Users{" "}
          </CustomText>
          <CustomText
            sx={{
              fontSize: "16px",
              textAlign: "start",
              color: colors.grayLight,
              fontWeight: 400,
            }}
          >
            {" "}
            - Display only deactivated users by admin
          </CustomText>
        </Box>
        <Box sx={{ m: "30px", display: "flex", alignItems: "start" }}>
          <SearchField
            sx={{
              maxWidth: "579px",
              "& .MuiOutlinedInput-input": {
                background: "rgba(168, 88, 15, 0.06) !important",
              },
              background: "rgba(168, 88, 15, 0.06) !important",
            }}
            onChange={(e) => setSearchText(e)}
          />
        </Box>
        {isLoading ? (
          <CustomLoader />
        ) : (
          <CustomTable
            rows={rows(verified_users, searchText, profileView)}
            headCells={column}
            rowsPerPage={rowsPerPage}
            page={page}
            setPage={handleChangePage}
            setRowsPerPage={handleChangeRowsPerPage}
            totalCount={verified_count}
          />
        )}
      </Card>
    </>
  );
};
export default VerifyUsers;
